import { useEffect, useState } from "react";

const keyBoard: string[] = "QWERTYUIOPASDFGHJKLÑZXCVBNM".split("");

const bandNames = [
  "Iron Maiden",
  "Foo Fighters",
  "Nirvana",
  "Kiss",
  "AC DC",
  "Metallica",
  "Soundgarden",
  "Led Zeppellin",
  "Los Pericos",
  "Catupecu Machu",
  "Seru Giran",
  "Callejeros",
  "Rata Blanca",
  "Hermética",
  "Ratones Paranoicos",
  "Riff",
  "Massacre",
  "Los Piojos",
  "Steve Wonder",
  "Jacbon Collier",
  "John Mayer",
  "Michael Jackson",
  "Duran Duran",
  "The Who",
  "Public Enemy",
  "Pink Floyd",
  "The Beatles",
  "Nirvana",
  "Queen",
  "Ad Infinitum",
  "Disturbed",
  "Avenged Sevenfold",
  "Apocalyptica",
  "Red Hot Chilli Peppers"
];

const useAhoracado = () => {
  const [wrongLetters, setWrongLetters] = useState<string[]>([]);
  const [rightLettersWritten, setrightLettersWritten] = useState<string[]>([]);
  const [currentBand, setcurrentBand] = useState<string>("");
  const [rightLetters, setRightLetters] = useState<string[]>([]);

  const handleClickLetter = (
    letter: string,
    word: Array<string> | undefined
  ) => {
    const bandToUpperCase = word?.map(l => l.toUpperCase());
    if (bandToUpperCase?.includes(`${letter}`)) {
      setrightLettersWritten(prev => [...prev, letter]);
    } else {
      setWrongLetters(prev => [...prev, letter]);
    }
  };

  function removeDuplicates(array: Array<string>) {
    return array.filter((el, index) => array.indexOf(el) === index);
  }

  const selectBand = () => {
    const bandIndex = Math.floor(Math.random() * bandNames.length - 1);
    const bandSelected = bandNames[bandIndex].toUpperCase();
    setcurrentBand(bandSelected);
    const auxWord = bandSelected.replace(" ", "").split("");
    const auxWordArray = removeDuplicates(auxWord);
    setRightLetters(auxWordArray);
  };

  useEffect(() => {
    selectBand();
  }, []);

  const reStart = () => {
    selectBand();
    setWrongLetters([]);
    setrightLettersWritten([]);
  };

  return {
    keyBoard,
    handleClickLetter,
    wrongLetters,
    rightLetters,
    rightLettersWritten,
    currentBand,
    reStart
  };
};

export default useAhoracado;
